<template>
  <button class="btn-success btn">
    <slot></slot>
  </button>
</template>

<script>
export default {};
</script>

<style>
/* button {
  cursor: pointer;
} */

.btn-light {
  border: 1px solid red;
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: var(--green);
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* background-color: transparent;  <-- REMOVIDO */
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.35rem;
  transition: color 0.15s ease-in-out,
              background-color 0.15s ease-in-out,
              border-color 0.15s ease-in-out,
              box-shadow 0.15s ease-in-out;
}

.btn-success {
  padding: 0.5rem 1rem;
  background-color: var(--green);
  color: #fff;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: .3rem;
  border: 1px solid red;
}

.btn-success:hover {
  color: #fff;
  background-color: var(--green_hover);
}

.btn-success:focus {
  color: #fff;
  background-color: var(--green_focus);
}

@media (max-width: 320px) {
  .btn-success {
    position: relative;
    left: 1rem;
  }
}
</style>